// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"__100w-flexible-solar-panel_productcontent___1W1D"};